require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-sigless.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-sigless");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-sigless!./.cache/json/betreuungseinrichtungen-mattersburg-sigless.json
// module id = 939
// module chunks = 231608221292675